import { render, staticRenderFns } from "./showImg.vue?vue&type=template&id=e77a1644&scoped=true"
import script from "./showImg.vue?vue&type=script&lang=js"
export * from "./showImg.vue?vue&type=script&lang=js"
import style0 from "./showImg.vue?vue&type=style&index=0&id=e77a1644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77a1644",
  null
  
)

export default component.exports